const PT = require("prop-types");
const React = require("react");
const moment = require("moment");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const Link = require("./Link");
const URLMake = require("../../../shared/URLMake");
const AT = require("../vault/ActionTypes");
const ImageLoader = require("../util/ImageLoader");

const styles = require("./styles/PrivacyChangeAlert.css");

const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "PrivacyChangeAlert",

		propTypes: {
			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			showPrivacyChangeAlert: function(changeDate) {
				this.setState({isOpen: true, changeDate});
			},

			resetVaultState: function() {
				this.setState({isOpen: false});
			},
		},

		getInitialState: function() {
			return {
				isOpen: false,
				changeDate: null,
			};
		},

		componentDidMount: function() {
			ImageLoader.preload(
				global.BASE_URL + "assets/images/office/elements/x-icon.svg"
			);
		},

		onClose: function() {
			this.setState({isOpen: false});
			this.props.dispatch({type: AT.ACCEPT_PRIVACY_REQUEST});
		},

		render: function() {
			const {isOpen, changeDate} = this.state;

			const niceDate = moment(changeDate).format("MMMM DD, YYYY");

			if (!isOpen) return null;

			return (
				<div className={styles.main}>
					<div className={styles.text}>
						{`We've updated our Privacy Policy, effective ${niceDate}. Please `}
						<Link
							to={URLMake.forPrivacy()}
							className={styles.link}
							clickAction={this.onClose}
						>
							{"click here"}
						</Link>
						{` to view the new version.`}
					</div>
					<div className={styles.close} onClick={this.onClose}>
						<div className={styles.closeImg} />
					</div>
				</div>
			);
		},
	})
);
